module.exports = __webpack_public_path__ + "static/media/irrf-auto-retencao.9ccc892d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/irrf-auto-retencao.png
// module id = 628
// module chunks = 0